import React from 'react';
import ActivePlansPriceList from './ActivePlansPriceList';
import PublicBacQueryPage from './PublicBacQueryPage';

/**
 * Wrapper component to determine which flow to use for /activeplanspricelist route
 * - For NEW_FLOW_AFFILIATES: Use new public flow → PublicBacQueryPage
 * - For all other affiliates: Use old screens → ActivePlansPriceList
 */
const ActivePlansPriceListWrapper = () => {
  // Extract affiliate DNS name from URL (e.g., 'cigna' from 'cigna-member.mpoweredhealth.com')
  const affiliateDnsName = window.location.href.split('/')[2].split('-')[0].toLowerCase();
  
  // Define affiliates that should use the new public flow
  const NEW_FLOW_AFFILIATES = ['cigna', 'medcost', 'mmo'];
  
  // Check if current affiliate should use new public flow
  const useNewPublicFlow = NEW_FLOW_AFFILIATES.includes(affiliateDnsName);
  
  // Render appropriate component based on affiliate
  if (useNewPublicFlow) {
    // New public flow: Redirect to price-transparency find-care screens without any token or params
    return <PublicBacQueryPage affiliateDnsName={affiliateDnsName} />;
  } else {
    // Old flow: Show existing ActivePlansPriceList screens
    return <ActivePlansPriceList />;
  }
};

export default ActivePlansPriceListWrapper;
